
import React, { useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Row, Container, Col } from 'react-bootstrap';
import './App.css';
import PaginaCotaCapital from "./modulos/pagina-cota-capital/PaginaCotaCapital";


function App() {

  return (
    <div id="wrapper ">
        <Routes>
          <Route exact path="/" element={<PaginaCotaCapital />} />
          <Route exact path="/cota-capital-web" element={<PaginaCotaCapital />} />
        </Routes>
      </div>
  );
}


export default App;
